module.exports = __webpack_public_path__ + "static/logo-640a28bde8b829f4e9698092cb9b1545.png";